const ID_TOKEN_KEY = "id_token";
const ACCESS_TOKEN_KEY = "access_token";
const TOKEN_EXPIRATION_KEY = "token_expiration";
const USER = "user";
const BASE_URL = process.env.VUE_APP_MIDDLE_URL;
const SITE = "site";
const VERSION_BDD = "versionBdd";

const PROVIDER = "gestionnaire";

import store from "../store";
import { rules, hasRule, espaceBeneficiaireRules as rulesEB, espaceGestionRules as rulesEspaceGestion, sites, extractionRules, espaceRPARules } from "@/utils/rulesHelper";
import {isEmpty} from "@/utils/fileHelper";

export function getBaseUrl() {
  return BASE_URL;
}

export function getProvider() {
  return PROVIDER;
}

export function getIdToken() {
  return localStorage.getItem(ID_TOKEN_KEY);
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getTokenExpirationDate() {
  return localStorage.getItem(TOKEN_EXPIRATION_KEY);
}

export function getUser() {
  return JSON.parse(localStorage.getItem(USER));
}

export function getCurrentSite() {
  return localStorage.getItem(SITE);
}

export function getVersionBdd() {
  return localStorage.getItem(VERSION_BDD);
}

function clearIdToken() {
  localStorage.removeItem(ID_TOKEN_KEY);
}

function clearAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

function clearTokenExpiration() {
  localStorage.removeItem(TOKEN_EXPIRATION_KEY);
}

function clearUser() {
  localStorage.removeItem(USER);
}

function clearVersionBdd() {
  // console.log('localStorage.getItem("VERSION_BDD")',localStorage.getItem('VERSION_BDD'))
  if (localStorage.getItem(VERSION_BDD) !== 'undefined' && localStorage.getItem(VERSION_BDD) !== null) {
    localStorage.removeItem(VERSION_BDD);
  }
}

export function clearSite() {
  localStorage.removeItem(SITE);
}

// Get and store access_token in local storage
export function setAccessToken(accessToken) {
  // let accessToken = getParameterByName('access_token')
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

// Get and store id_token in local storage
export function setIdToken(idToken) {
  // let idToken = getParameterByName('id_token')
  localStorage.setItem(ID_TOKEN_KEY, idToken);
}

export function setTokenExpiration(TokenExpiration) {
  // let idToken = getParameterByName('id_token')
  localStorage.setItem(TOKEN_EXPIRATION_KEY, TokenExpiration);
}

export function setUser(User) {
  localStorage.setItem(USER, JSON.stringify(User));
}

export function setCurrentSite(site) {
  localStorage.setItem(SITE, site);
}

export function setVersionBdd(version) {
  // console.log(version)
  localStorage.setItem(VERSION_BDD, version);
}

export function isLoggedIn() {
  const idToken = getIdToken();
  return !!idToken && !isTokenExpired(idToken);
}

export function isTokenExpired() {
  let date = new Date();
  date =
    date.getFullYear() +
    "-" +
    ("00" + (date.getMonth() + 1)).slice(-2) +
    "-" +
    ("00" + date.getDate()).slice(-2) +
    " " +
    date.getHours()  +
    ":" +
    date.getMinutes() +
    ":" +
    date.getSeconds();
  let expirationDate = getTokenExpirationDate();
  return new Date(expirationDate).getTime() < new Date(date).getTime();
}

export function handleLogin(data) {
  setAccessToken(data.access_token);
  setIdToken(data.token_type);
  setTokenExpiration(data.expires_at);
  if (!data.user.droit_particulier) {
    data.user.droit_particulier = {
      user_id: data.user.id,
      can_access_salarie: false,
      can_access_beneficiaire: false,
      can_access_echeancier: false
    };
  }
  handleUser(data.user);
  setVersionBdd(data.versionBdd);
}

export function handleUser(user) {
  let userModified = {};
  let userArray = Object.entries(user);
  for (const [key,value] of userArray) {
    userModified[key] = value;
    let suffiedKey = key + '_original';
    userModified[suffiedKey] = value;
  }
  // console.log('userModified',userModified)
  setUser(userModified);
  // setUser(user);
}

export function handleLogout(type) {
  clearIdToken();
  clearAccessToken();
  clearTokenExpiration();
  clearUser();
  clearSite();
  clearVersionBdd();
  if (type !== "chorumfr") {
    if (type) {
      window.location.href = "/login?t=" + type;
    } else {
      window.location.href = "/login";
    }
  }
}

export function requireAuth(to, from, next) {
  if (!isLoggedIn()) {
    handleLogout();
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
  } else {
    // console.log('to.meta.rule',to.meta.rule)
    // On regarde s'il y a un droit d'accès à la route et si l'utilisateur a le droit
    if(to && to.meta && to.meta.rule != undefined){
      if(hasRule(to.meta.rule)) {
          next()
      }else{
        alert('Vous n\'avez pas le droit d\'accéder à cette page.')
        next({
          path: "/",
          // query: { redirect: to.fullPath }
        });
      }
    }else{
      next()
    }
  }
}

export function hasHabilitationOagOapDossier(dossier) {
  if (isEmpty(dossier)) {
    return false;
  }
  if (isEmpty(dossier.oag) || isEmpty(dossier.oap)) {
    return false;
  }
  let user = getUser();
  if (user && user.profil_active && user.profil_active[0]) {
    let authorizedOags = user.profil_active[0].oags.map(oag => oag.code);
    let authorizedOaps = user.profil_active[0].oaps.map(oap => oap.code);
    let hasOag = authorizedOags.indexOf(dossier.oag) > -1
    let hasOap = authorizedOaps.indexOf(dossier.oap) > -1

    // console.log(authorizedOags,authorizedOaps, dossier.oag, dossier.oap, hasOag, hasOap)
    return hasOap && hasOag;
  } else {
    return false;
  }
  // console.log('user',user)
  return false;
}
